import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, HiddenSpan } from 'components'
import * as Types from 'types'
import { CopyArtistPartnershipsForm } from '../forms'

const propTypes = {
  onClose: PropTypes.func.isRequired,
  partnerships: PropTypes.arrayOf(Types.partnership),
  onSubmit: PropTypes.func.isRequired,
  onSubmitSuccess: PropTypes.func.isRequired,
  schoolYears: PropTypes.arrayOf(Types.schoolYear).isRequired,
}

const defaultProps = {
  partnerships: [],
}

function CopyArtistPartnershipModal({
  onClose,
  partnerships,
  onSubmit,
  onSubmitSuccess,
  schoolYears,
}) {
  const [submitFailCount, setSubmitFailCount] = useState(0)
  return (
    <Modal onClose={onClose}>
      <h2>Copy Existing Teaching Artist</h2>
      <div className="modal-content">
        <p>
          Please note: when copying existing Teaching Artists from a specific
          school year, you are copying all associated programs that occurred
          during the selected year. You can always adjust your associations for
          the current year after copying information from previous years.
        </p>
        {partnerships.length ? (
          <CopyArtistPartnershipsForm
            partnerships={partnerships}
            onSubmit={onSubmit}
            onSubmitSuccess={onSubmitSuccess}
            onSubmitFail={() => {
              setSubmitFailCount((sfc) => sfc + 1)
            }}
            schoolYears={schoolYears}
          >
            {(error) => (
              <div role="alert" aria-atomic>
                {error && (
                  <p className="full-error-message">
                    <span className="visually-hidden">Form invalid: </span>
                    {/* The hidden count will force screen readers to announce
                     the error again even when it's exactly the same */}
                    {error} <HiddenSpan>{submitFailCount}</HiddenSpan>
                  </p>
                )}
              </div>
            )}
          </CopyArtistPartnershipsForm>
        ) : (
          <p>
            <strong>No other partnerships found.</strong>
          </p>
        )}
      </div>
    </Modal>
  )
}

CopyArtistPartnershipModal.propTypes = propTypes
CopyArtistPartnershipModal.defaultProps = defaultProps

export default CopyArtistPartnershipModal
